export interface LoginUserInterface {
  email?: string;
  username?: string;
  password: string;
  adminApp?: boolean;
}
